import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';

export const devCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('dev')
    .option('-s, --https', t('dev_command_def.option.https'))
    .action(async (options, command) => {
      const { DevCommand } = await import('../components/DevCommand/index.js');
      const { renderCommand } = await import('./render-command.js');

      const { https = false } = options;

      await renderCommand(command, services, <DevCommand https={https} />, {
        watchForModelChanges: true,
      });
    });
};
